import React from 'react';
import { Modal, Spin, Alert } from 'antd';

export const UnreadMessagesModal = ({ visible, onClose, loading, error, data }) => (
  <Modal title="Unread Messages Detail" open={visible} onCancel={onClose} footer={null} width={700}>
    <Spin spinning={loading} tip="Loading messages...">
      {error ? (
        <Alert type="error" message="Error loading messages" description={error?.message || error} />
      ) : (
        <div style={{ maxHeight: 400, overflowY: 'auto' }}>
          {Array.isArray(data) && data.length > 0 ? (
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr>
                  <th style={{ borderBottom: '1px solid #eee', padding: '8px' }}>School</th>
                  <th style={{ borderBottom: '1px solid #eee', padding: '8px' }}>Type</th>
                  <th style={{ borderBottom: '1px solid #eee', padding: '8px' }}>Plan</th>
                  <th style={{ borderBottom: '1px solid #eee', padding: '8px' }}>Unread Count</th>
                </tr>
              </thead>
              <tbody>
                {data.map((msg, idx) => (
                  <tr key={idx}>
                    <td style={{ padding: '8px', borderBottom: '1px solid #f5f5f5' }}>
                      <a
                        target="_blank"
                        href={`/admin/v2/schools/${msg.school_id}/communication-hub/messages`}
                        rel="noreferrer">
                        {msg.school_name}
                      </a>
                    </td>
                    <td style={{ padding: '8px', borderBottom: '1px solid #f5f5f5' }}>{msg.communication_type}</td>
                    <td style={{ padding: '8px', borderBottom: '1px solid #f5f5f5' }}>{msg.plan_id}</td>
                    <td style={{ padding: '8px', borderBottom: '1px solid #f5f5f5', textAlign: 'center' }}>
                      {msg.total}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div>No unread messages found.</div>
          )}
        </div>
      )}
    </Spin>
  </Modal>
);
